import { useContext, useEffect, useState } from 'react';
import CompleteSignup from '../CompleteSignup';
import { useFormik } from 'formik';
import { signUpAgent } from '@services/Api';
import { UserContext } from '@context/createContext';
import ToastError from '../../toast/ToastError';
import { getCookie, setCookie, validateNationalID } from '@helper/functions';
import ToastSuccess from '../../toast/ToastSuccess';

export default function SignupRealestate() {
  const [signUp, setSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(null); // Store the cookie value in state
  const { refetch } = useContext(UserContext);

  useEffect(() => {
    const fetchCookie = async () => {
      const cookieId = await getCookie('id');
      setId(cookieId);
    };
    fetchCookie();
  }, []);

  const formikSignUpAgent = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      nationalID: '',
    },
    validate: (values) => {
      const errors = {};
      if (!values.firstName.trim()) {
        errors.firstName = 'نام را وارد کنید';
      }
      if (!values.lastName.trim()) {
        errors.lastName = 'نام خانوادگی را وارد کنید';
      }
      if (!values.nationalID) {
        errors.nationalID = 'کد ملی را وارد کنید';
      } else if (!validateNationalID(values.nationalID)) {
        errors.nationalID = 'لطفا یک کد ملی معتبر وارد کنید';
      }
      // else if (
      //   !/(^0?9[0-9]{9}$)|(^\u06F0\u06F9[\u06F0-\u06F9]{9})$/.test(values.phone)
      // ) {
      //   errors.phone = "شماره موبایل وارد شده اشتباه است";
      // }

      return errors;
    },
    onSubmit: (values) => {
      setLoading(true);
      const dataAgent = {
        fullname: formikSignUpAgent.values.firstName.trim() + ' ' + formikSignUpAgent.values.lastName.trim(),
        userType: 'agent',
        nationalId: formikSignUpAgent.values.nationalID,
      };

      signUpAgent(dataAgent, id)
        .then((res) => {
          if (res.status == 'success') {
            setSignUp(true);
            setCookie('accessToken', res.data.accessToken, 1);
            setCookie('refreshToken', res.data.refreshToken, 14);
            ToastSuccess({ content: 'ثبت نام مشاور با موفقیت انجام شد' });
          } else {
            ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید' });
          }
        })
        .catch((e) => {
          ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید' });
        })
        .finally((e) => {
          setLoading(false);
          refetch();
        });
    },
  });
  return (
    <>
      {!signUp ? (
        <div className="flex flex-col w-full h-full items-center justify-center gap-16">
          <h3 className="text-lg md:text-2xl 2xl:text-3xl font-bold whitespace-nowrap">
            برای ثبت نام اطلاعات زیر را تکمیل نمایید .
          </h3>
          <form
            onSubmit={formikSignUpAgent.handleSubmit}
            className="grid grid-cols-2 gap-x-4 gap-y-8 lg:gap-x-6 lg:gap-y-12 w-full max-w-[550px] place-items-start"
          >
            <div className="flex flex-col relative gap-1 col-span-1 w-full">
              <label className="text-sm lg:text-base" htmlFor="">
                نام
              </label>
              <input
                name="firstName"
                onChange={formikSignUpAgent.handleChange}
                onBlur={formikSignUpAgent.handleBlur}
                value={formikSignUpAgent.values.firstName}
                dir="rtl"
                className={`w-full rounded-lg border-[1.5px] ${
                  formikSignUpAgent.errors.firstName && formikSignUpAgent.touched.firstName
                    ? 'border-error'
                    : 'border-blackFont-200 focus:border-blackFont-900'
                } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
                placeholder="مثال : امیر رضا"
                type="text"
              />
              <span
                className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
                  formikSignUpAgent.errors.firstName && formikSignUpAgent.touched.firstName
                    ? 'visible opacity-100'
                    : 'invisible opacity-0'
                }`}
              >
                {formikSignUpAgent.errors.firstName}
              </span>
            </div>
            <div className="flex flex-col relative gap-1 col-span-1 w-full">
              <label className="text-sm lg:text-base" htmlFor="">
                نام خانوادگی
              </label>
              <input
                name="lastName"
                onChange={formikSignUpAgent.handleChange}
                onBlur={formikSignUpAgent.handleBlur}
                value={formikSignUpAgent.values.lastName}
                dir="rtl"
                className={`w-full rounded-lg border-[1.5px] ${
                  formikSignUpAgent.errors.lastName && formikSignUpAgent.touched.lastName
                    ? 'border-error'
                    : 'border-blackFont-200 focus:border-blackFont-900'
                } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
                placeholder="مثال : خسروی"
                type="text"
              />
              <span
                className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
                  formikSignUpAgent.errors.lastName && formikSignUpAgent.touched.lastName
                    ? 'visible opacity-100'
                    : 'invisible opacity-0'
                }`}
              >
                {formikSignUpAgent.errors.lastName}
              </span>
            </div>
            <div className="flex flex-col relative gap-1 col-span-2 w-full">
              <label className="text-sm lg:text-base" htmlFor="">
                کد ملی
              </label>
              <input
                name="nationalID"
                onChange={formikSignUpAgent.handleChange}
                onBlur={formikSignUpAgent.handleBlur}
                value={formikSignUpAgent.values.nationalID}
                dir="rtl"
                className={`w-full rounded-lg border-[1.5px] ${
                  formikSignUpAgent.errors.nationalID && formikSignUpAgent.touched.nationalID
                    ? 'border-error'
                    : 'border-blackFont-200 focus:border-blackFont-900'
                } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
                placeholder="باید 10 رقم باشد"
                type="text"
              />
              <span
                className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
                  formikSignUpAgent.errors.nationalID && formikSignUpAgent.touched.nationalID
                    ? 'visible opacity-100'
                    : 'invisible opacity-0'
                }`}
              >
                {formikSignUpAgent.errors.nationalID}
              </span>
            </div>
            <div className="sm:col-span-1 col-span-2 max-sm:w-full">
              <button type="submit" className="btn btn-primary max-sm:w-full">
                تایید و ثبت نام
              </button>
            </div>
          </form>
        </div>
      ) : (
        <CompleteSignup role="مشاور" />
      )}
    </>
  );
}
